"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addHeader = void 0;
const addHeader = (headers, headerName, headerValue) => {
    if (headers && headerValue && headerName) {
        headers[headerName] = headerValue;
    }
};
exports.addHeader = addHeader;
